import { createContext, useContext } from "react"
import type { PriceType } from "../types";
import { Wallet } from "~/features/wallet/types";

interface CheckoutContextType {
    step: number;
    setStep: React.Dispatch<React.SetStateAction<number>>;
    selectedPrice: PriceType | null;
    setSelectedPrice: React.Dispatch<React.SetStateAction<PriceType>>;
    selectedWallet?: Wallet;
    setSelectedWallet: React.Dispatch<React.SetStateAction<Wallet>>;
}

export const CheckoutContext = createContext<CheckoutContextType | undefined>(undefined)

export function useCheckoutContext() {
    const context = useContext(CheckoutContext)
    if (!context) {
        throw new Error('Checkout compound components must be used within Checkout')
    }
    return context
}